import { render, staticRenderFns } from "./VarroaNew.vue?vue&type=template&id=36f7a1c8&scoped=true&"
import script from "./VarroaNew.vue?vue&type=script&lang=js&"
export * from "./VarroaNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f7a1c8",
  null
  
)

export default component.exports